import { Routes, Route } from '@angular/router';
import { AnonymousGuard } from '@core/services';
import { AuthShellComponent } from './auth-shell.component';

export class AuthShell {
  /**
   * Creates routes using the shell component and authentication.
   * @param routes The routes to add.
   * @return The new route using shell as the base.
   */
  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: AuthShellComponent,
      children: routes,
      canActivate: [AnonymousGuard]
    };
  }
}
